export default __webpack_public_path__ + "assets/icons/search.16ba498a.svg";